import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../locales/en/common.json';
import enPortfolio from '../locales/en/portfolio.json';
import arCommon from '../locales/ar/common.json';
import arPortfolio from '../locales/ar/portfolio.json';

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: {
        common: enCommon,
        portfolio: enPortfolio
      },
      ar: {
        common: arCommon,
        portfolio: arPortfolio
      }
    },
    fallbackLng: 'en', // Fallback language
    defaultNS: 'common', // Default namespace
    ns: ['common', 'portfolio'], // Available namespaces
    supportedLngs: ['en', 'ar'], // Only these resolve; others fall back
    load: 'languageOnly', // ar-SA -> ar, en-US -> en

    // Language detection configuration
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first, then browser
      caches: ['localStorage'], // Cache user preference in localStorage
      lookupLocalStorage: 'i18nextLng' // Key to use in localStorage
    },

    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
